module.exports = __webpack_public_path__ + "static/media/whatsapp.47c77bf1.svg";